export default {
	"search.title": "Suche",
	"search.search": "Suchen",
	"search.close": "Suche schließen",
	"search.placeholder": "Suchbegriff...",
	"search.subtitle": "Geben Sie einen Suchbegriff ein.",
	"search.emptyResult": "Das hat leider nicht geklappt.",
	"search.notFound": "Es wurden keine Ergebnisse gefunden.",
	"search.text": "... {text} ...",
	"search.totalResults": "Gesamtergebnisse: {count}",
	"search.loading": "Lädt...",
	"search.error": "Fehler aufgetreten: {errorMessage}",
	"search.unknownError": "Unbekannter Fehler",
	"search.next": "Vor",
	"search.previous": "Zurück",
	"search.slug": "suche",
	"search.showMore": "Alle Ergebnisse ({count})",
	"search.commonSearchTerms": "Häufig gesucht...",
} as const;
